export default __webpack_public_path__ + "static/media/Standort_grün.653160a1.png";